import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  openLevel: '',
  currentLevel: 1,
  openMenu: false,
  i18n: {
    menuHomeButton: '',
    menuGoBackButton: '',
    mainMenuButton: '',
    menuStartButton: '',
    navLabel: '',
  },
});

export { state, onChange };
export default state;
